import type { ErrorResponse } from "@shared/types";
import type { AxiosError } from "axios";

/**
 * HTTP status code bo'yicha error kategoriyasi
 */
export type ErrorCategory =
	| "validation" // 400
	| "authentication" // 401
	| "forbidden" // 403
	| "not_found" // 404
	| "conflict" // 409
	| "server" // 500+
	| "network" // Connection errors
	| "timeout" // Request timeout
	| "unknown"; // Others

/**
 * Error kategoriyasini aniqlash
 */
export function categorizeError(error: AxiosError<ErrorResponse>): ErrorCategory {
	if (!error.response) {
		if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
			return "timeout";
		}
		if (error.code === "ERR_NETWORK" || error.message?.includes("Network Error")) {
			return "network";
		}
		return "unknown";
	}

	const status = error.response.status;

	switch (status) {
		case 400:
			return "validation";
		case 401:
			return "authentication";
		case 403:
			return "forbidden";
		case 404:
			return "not_found";
		case 409:
			return "conflict";
		default:
			if (status >= 500) {
				return "server";
			}
			return "unknown";
	}
}

/**
 * Error message dan foydalanuvchi uchun xabar olish
 */
export function getUserErrorMessage(
	error: AxiosError<ErrorResponse>,
	fallbackMessage?: string
): { message: string; description?: string } {
	const apiError = error.response?.data?.error;

	if (apiError) {
		return {
			message: apiError.message || fallbackMessage || "Xatolik yuz berdi",
			description: undefined,
		};
	}

	// Network xatolari
	const category = categorizeError(error);

	switch (category) {
		case "network":
			return {
				message: "Internet bilan aloqa yo'q",
				description: "Ulanishingizni tekshiring va qayta urinib ko'ring.",
			};
		case "timeout":
			return {
				message: "So'rov vaqti tugadi",
				description: "Server javob bermadi. Qayta urinib ko'ring.",
			};
		case "server":
			return {
				message: "Serverda xatolik yuz berdi",
				description: "Muammo hal qilinmoqda. Birozdan so'ng qayta urinib ko'ring.",
			};
		default:
			return {
				message: fallbackMessage || "Xatolik yuz berdi",
				description: undefined,
			};
	}
}
